/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SetClientContactMappingPayload = {
    /**
     * External contact ID from the accounting provider
     */
    externalContactId: string;
    /**
     * How the mapping was created
     */
    mappingType?: SetClientContactMappingPayload.mappingType;
};
export namespace SetClientContactMappingPayload {
    /**
     * How the mapping was created
     */
    export enum mappingType {
        MANUAL = 'manual',
        AUTO = 'auto',
        SUGGESTED = 'suggested',
    }
}

